module.exports = __webpack_public_path__ + "img/startup.e93f466a.jpg";